import React from "react";
import ReactDOM from "react-dom/client"; // ✅ use react-dom/client for React 18
import App from "./App";

// Context
import { ProfileUserProvider } from "./lib/profileContext";

// Get the container (the <div id="root"> in index.html)
const container = document.getElementById("root");

// Create root using the new React 18 API
const root = ReactDOM.createRoot(container);

// Render your app inside the provider
root.render(
  <React.StrictMode>
    <ProfileUserProvider>
      <App />
    </ProfileUserProvider>
  </React.StrictMode>
);
